import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'components/Luxkit/Typography/BodyText'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${rem(36)};
`

const Loading = styled(LoadingIndicator)`
  padding: 0;
  margin-left: ${rem(20)};
`

function LoadingAirports() {
  return (
    <Wrapper>
      <BodyText variant="large" weight="bold" colour="neutral-one">Loading</BodyText>
      <Loading visible inline/>
    </Wrapper>
  )
}

export default LoadingAirports
